import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Check, Target, ArrowRight } from "lucide-react";

export default function About() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return <div className="p-20 text-center text-zinc-500">Loading…</div>;
  const a = c.about;

  return (
    <div data-testid="about-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <span className="text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]">Who we are</span>
          <h1 data-testid="about-heading" className="display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter font-bold mt-4 leading-[0.95]">{a.heading}</h1>
          <p data-testid="about-intro" className="text-base text-zinc-300 mt-7 leading-relaxed whitespace-pre-line">{a.intro}</p>

          {a.mission && (
            <div className="mt-10 border-l-2 border-[#00e5ff] pl-6">
              <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 flex items-center gap-1"><Target className="w-3 h-3" /> Our mission</p>
              <p data-testid="about-mission" className="display text-2xl uppercase tracking-tight font-bold mt-3 leading-tight">{a.mission}</p>
            </div>
          )}

          {a.values?.length > 0 && (
            <ul data-testid="values" className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {a.values.map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm text-zinc-300"><Check className="w-4 h-4 text-[#00e5ff] shrink-0 mt-0.5" /> {v}</li>
              ))}
            </ul>
          )}

          <div className="mt-12 border border-white/10 p-6">
            <p className="text-[10px] uppercase tracking-widest text-zinc-500">How we make money</p>
            <p className="text-sm text-zinc-300 mt-3 leading-relaxed">
              GoalieHub earns a commission on bookings made through this site. The service fee is always shown
              at checkout before you pay.
            </p>
            <Link to="/disclosure" data-testid="about-disclosure-link" className="mt-4 inline-flex items-center gap-1 text-[11px] uppercase tracking-widest text-[#00e5ff] hover:underline">
              Read the full disclosure <ArrowRight className="w-3 h-3" />
            </Link>
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="border border-white/10 bg-[#121212] p-8 lg:sticky lg:top-24">
            {a.bio_photo ? (
              <img data-testid="about-bio-photo" src={a.bio_photo} alt={a.bio_name} className="w-full h-64 object-cover border border-white/10" />
            ) : (
              <div className="w-full h-40 border border-dashed border-white/15 flex items-center justify-center text-[11px] uppercase tracking-widest text-zinc-600">Add a photo in admin</div>
            )}
            <p data-testid="about-bio-name" className="display text-2xl uppercase tracking-tight font-bold mt-6 leading-none">{a.bio_name}</p>
            <p data-testid="about-bio-role" className="text-[11px] uppercase tracking-widest text-[#00e5ff] mt-2">{a.bio_role}</p>
            <p data-testid="about-bio-text" className="text-sm text-zinc-300 mt-5 leading-relaxed whitespace-pre-line">{a.bio_text}</p>
            {(a.contact_email || a.location) && (
              <div className="mt-6 pt-5 border-t border-white/10 space-y-1">
                {a.location && <p className="text-xs text-zinc-500">{a.location}</p>}
                {a.contact_email && <p data-testid="about-contact" className="text-xs text-zinc-400">{a.contact_email}</p>}
              </div>
            )}
          </div>
        </aside>
      </div>
    </div>
  );
}
